import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=7efbfe62"
import script from "./inputs.vue?vue&type=script&lang=js"
export * from "./inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports